import { render, staticRenderFns } from "./PurchasePlanUpgrade.vue?vue&type=template&id=1a8c7e22"
import script from "./PurchasePlanUpgrade.vue?vue&type=script&lang=js"
export * from "./PurchasePlanUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports